import { TimeFormat } from '@treadinc/horizon-api-spec';
import dayjs from 'dayjs';
import { t } from 'i18next';

import {
  convertWallClockToTimeZone,
  fromWallClock,
  getHoursAheadOfSite,
  getTimeZoneAbbreviation,
  getTimeZoneLongName,
  SITE_TIME_FORMAT_BY_TIME_FORMAT,
} from '~pages/Settings/Administration/Sites/site-form-v2/siteTime';

/** "04:00 AM your time (PDT)" for a site wall-clock time, or nothing when the zones match. */
export const describeWallClockInUserTime = ({
  siteTimeZone,
  timeFormat,
  userTimeZone,
  wallClock,
}: {
  siteTimeZone: string;
  timeFormat: TimeFormat;
  userTimeZone: string;
  wallClock: string | null;
}) => {
  const now = dayjs();
  const userIsInSiteTimeZone = getHoursAheadOfSite(siteTimeZone, userTimeZone, now) === 0;
  if (!wallClock || userIsInSiteTimeZone) {
    return undefined;
  }

  const userTime = convertWallClockToTimeZone(wallClock, siteTimeZone, userTimeZone, now);

  return t('administration.site.time_in_your_zone', {
    time: userTime.format(SITE_TIME_FORMAT_BY_TIME_FORMAT[timeFormat]),
    zone: getTimeZoneAbbreviation(userTimeZone, now),
  });
};

/** Caption under the hours inputs; names the zone once the site has one. */
export const describeSiteTimeZoneHint = (siteTimeZone: string | null) =>
  siteTimeZone
    ? t('administration.site.enter_times_in_site_zone', {
        zone: getTimeZoneLongName(siteTimeZone, dayjs()),
      })
    : t('administration.site.enter_times_in_site_local_time');

export const formatSiteHours = (
  openAt: string | null,
  closeAt: string | null,
  timeFormat: TimeFormat,
) => {
  const open = fromWallClock(openAt);
  const close = fromWallClock(closeAt);
  if (!open || !close) {
    return t('administration.site.no_hours_set');
  }

  const clockFormat = SITE_TIME_FORMAT_BY_TIME_FORMAT[timeFormat];

  return `${open.format(clockFormat)} – ${close.format(clockFormat)}`;
};
